import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class TouchbackPunterStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            !play.historyContains(FootballState.KickOff) &&
            [FootballState.Punt, FootballState.CflKick].some(
                (state) => state === fragment.associatedState
            ) &&
            play
                .getFragmentsBetween(fragment, [FootballState.CflKick])
                .some(
                    ({ associatedState }) =>
                        associatedState === FootballState.TouchBack
                ) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.puntedBy.teamId,
            playerId: fragment.puntedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.PUNT,
            values: {
                touchback: 1
            }
        });
    }
}
